<template>
    <div class="coin-icon">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="1 0 90 109">
            <circle :fill="colors.theme == 'dark' ? '#000' : '#ccd5d3'" class="cls-1" cx="48" cy="60" r="48"/>
            <circle cx="48" cy="48" r="48" :fill="colors.secondary"/>
            <rect class="cls-3" fill="#fff" x="31" y="44.14" width="37" height="10.75" transform="translate(99.01 0.01) rotate(90)"/>
            <rect class="cls-3" fill="#fff" x="31" y="44.14" width="37" height="10.75" transform="translate(99 99.02) rotate(180)"/></svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
        // console.log('Colors: ', this.colors)
    }
}
</script>

<style lang="scss" scoped>
svg{
    // height: 40px;
}
// .cls-1{fill:#ccd5d3;}
// .cls-1{opacity:.15;}
</style>
